import { COLOR } from 'src/constants/colors'
import { SvgPropsType } from 'src/types/types'
import styled from 'styled-components'

const HomeIcon = (props: SvgPropsType) => {
  const { width, height, name } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3790_27217)">
        <path
          d="M7.55566 34.8535V16.1868L20.0779 6.85352L32.4446 16.1868V34.8535H23.3446V23.7702H16.6168V34.8535H7.55566Z"
          fill={name === 'home' ? COLOR.black40 : COLOR.white}
          stroke="white"
          strokeWidth="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_3790_27217">
          <path
            d="M0 0.855469H28C34.6274 0.855469 40 6.22805 40 12.8555V28.8555C40 35.4829 34.6274 40.8555 28 40.8555H0V0.855469Z"
            fill={name === 'home' ? COLOR.black40 : COLOR.white}
          />
        </clipPath>
      </defs>
    </svg>
  )
}
const FileIcon = (props: SvgPropsType) => {
  const { width, height, name } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
    >
      <g clipPath="url(#clip0_3790_27179)">
        <path
          d="M16.6668 7.09436H6.66683C4.8335 7.09436 3.35016 8.59436 3.35016 10.4277L3.3335 30.4277C3.3335 32.261 4.8335 33.761 6.66683 33.761H33.3335C35.1668 33.761 36.6668 32.261 36.6668 30.4277V13.761C36.6668 11.9277 35.1668 10.4277 33.3335 10.4277H20.0002L16.6668 7.09436Z"
          fill={
            name === 'file_grey'
              ? COLOR.black40
              : name === 'file_active'
              ? COLOR.white
              : COLOR.black100
          }
        />
      </g>
      <defs>
        <clipPath id="clip0_3790_27179">
          <rect
            width="40"
            height="40"
            fill={
              name === 'file_grey'
                ? COLOR.black40
                : name === 'file_active'
                ? COLOR.white
                : COLOR.black100
            }
            transform="translate(0 0.427734)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const LocateIcon = (props: SvgPropsType) => {
  const { width, height, name } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
    >
      <g clipPath="url(#clip0_3790_27173)">
        <path
          d="M20.0002 4.18884C13.5502 4.18884 8.3335 9.40551 8.3335 15.8555C8.3335 24.6055 20.0002 37.5222 20.0002 37.5222C20.0002 37.5222 31.6668 24.6055 31.6668 15.8555C31.6668 9.40551 26.4502 4.18884 20.0002 4.18884ZM20.0002 20.0222C17.7002 20.0222 15.8335 18.1555 15.8335 15.8555C15.8335 13.5555 17.7002 11.6888 20.0002 11.6888C22.3002 11.6888 24.1668 13.5555 24.1668 15.8555C24.1668 18.1555 22.3002 20.0222 20.0002 20.0222Z"
          fill={name === 'locate' ? COLOR.black40 : COLOR.white}
        />
      </g>
      <defs>
        <clipPath id="clip0_3790_27173">
          <rect
            width="40"
            height="40"
            fill={name === 'locate' ? COLOR.black40 : COLOR.white}
            transform="translate(0 0.855469)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const VideoCallIcon = (props: SvgPropsType) => {
  const { width, height, name } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
    >
      <g clipPath="url(#clip0_3790_27193)">
        <path
          d="M28.3333 18.355V12.5216C28.3333 11.605 27.5833 10.855 26.6667 10.855H6.66667C5.75 10.855 5 11.605 5 12.5216V29.1883C5 30.105 5.75 30.855 6.66667 30.855H26.6667C27.5833 30.855 28.3333 30.105 28.3333 29.1883V23.355L35 30.0216V11.6883L28.3333 18.355Z"
          fill={name === 'video_call' ? COLOR.black40 : COLOR.white}
        />
      </g>
      <defs>
        <clipPath id="clip0_3790_27193">
          <rect
            width="40"
            height="40"
            fill={name === 'video_call' ? COLOR.black40 : COLOR.white}
            transform="translate(0 0.85498)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const SettingIcon = (props: SvgPropsType) => {
  const { width, height, name } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
    >
      <g clipPath="url(#clip0_3790_27185)">
        <path
          d="M31.8999 22.4221C31.9665 21.9221 31.9999 21.4055 31.9999 20.8555C31.9999 20.3221 31.9665 19.7888 31.8832 19.2888L35.2665 16.6555C35.5665 16.4221 35.6499 15.9721 35.4665 15.6388L32.2665 10.1055C32.0665 9.7388 31.6499 9.62214 31.2832 9.7388L27.2999 11.3388C26.4665 10.7055 25.5832 10.1721 24.5999 9.77213L23.9999 5.5388C23.9332 5.1388 23.5999 4.85547 23.1999 4.85547H16.7999C16.3999 4.85547 16.0832 5.1388 16.0165 5.5388L15.4165 9.77213C14.4332 10.1721 13.5332 10.7221 12.7165 11.3388L8.73319 9.7388C8.36652 9.60547 7.94986 9.7388 7.74986 10.1055L4.56652 15.6388C4.36652 15.9888 4.43319 16.4221 4.76652 16.6555L8.14986 19.2888C8.06652 19.7888 7.99986 20.3388 7.99986 20.8555C7.99986 21.3721 8.03319 21.9221 8.11652 22.4221L4.73319 25.0555C4.43319 25.2888 4.34986 25.7388 4.53319 26.0721L7.73319 31.6055C7.93319 31.9721 8.34986 32.0888 8.71652 31.9721L12.6999 30.3721C13.5332 31.0055 14.4165 31.5388 15.3999 31.9388L15.9999 36.1721C16.0832 36.5721 16.3999 36.8555 16.7999 36.8555H23.1999C23.5999 36.8555 23.9332 36.5721 23.9832 36.1721L24.5832 31.9388C25.5665 31.5388 26.4665 31.0055 27.2832 30.3721L31.2665 31.9721C31.6332 32.1055 32.0499 31.9721 32.2499 31.6055L35.4499 26.0721C35.6499 25.7055 35.5665 25.2888 35.2499 25.0555L31.8999 22.4221ZM19.9999 26.8555C16.6999 26.8555 13.9999 24.1555 13.9999 20.8555C13.9999 17.5555 16.6999 14.8555 19.9999 14.8555C23.2999 14.8555 25.9999 17.5555 25.9999 20.8555C25.9999 24.1555 23.2999 26.8555 19.9999 26.8555Z"
          fill={name === 'setting' ? COLOR.black40 : COLOR.white}
        />
      </g>
      <defs>
        <clipPath id="clip0_3790_27185">
          <rect
            width="40"
            height="40"
            fill={name === 'setting' ? COLOR.black40 : COLOR.white}
            transform="translate(0 0.855469)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
const WifiIcon = (props: SvgPropsType) => {
  const { width, height, name } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.012 14.1732C11.1734 14.1732 12.1149 13.2317 12.1149 12.0704C12.1149 10.909 11.1734 9.96753 10.012 9.96753C8.85066 9.96753 7.90918 10.909 7.90918 12.0704C7.90918 13.2317 8.85066 14.1732 10.012 14.1732Z"
        fill={name === 'wifi' ? COLOR.black30 : COLOR.brand}
      />
      <path
        d="M15.0407 7.0047C15.0095 6.97263 14.9766 6.94403 14.9445 6.91456L14.85 6.82528C14.8344 6.80881 14.8171 6.79667 14.7972 6.78107C12.078 4.3107 7.91655 4.40865 5.32136 7.00384L5.01712 7.30895L4.59585 7.73021C4.08271 8.24335 4.08531 9.07981 4.59932 9.59382C5.1142 10.1096 5.95066 10.1104 6.46293 9.59729L7.18931 8.87092C8.83969 7.2214 11.5242 7.2214 13.1737 8.87005L13.6981 9.37799C14.206 9.88593 15.0347 9.88507 15.5452 9.37366C15.7923 9.12749 15.9283 8.79897 15.9292 8.44965C15.9301 8.10207 15.7957 7.77355 15.5487 7.52825L15.0407 7.0047Z"
        fill={name === 'wifi' ? COLOR.black30 : COLOR.brand}
      />
      <path
        d="M18.6214 4.40381L18.1845 3.96694C18.1828 3.96521 18.1819 3.96261 18.1784 3.96174L17.8335 3.61502C17.7728 3.55521 17.7069 3.5032 17.6376 3.45813C13.2056 -0.432916 6.46457 -0.313298 2.17393 3.81438C2.15313 3.83345 2.12972 3.84646 2.10892 3.86726L1.32014 4.65691C0.852067 5.12411 0.854667 5.88429 1.32534 6.35496C1.79514 6.82477 2.55532 6.82823 3.02339 6.3593L3.81217 5.57138C3.81738 5.56445 3.82171 5.55838 3.82691 5.55404C7.29669 2.20214 12.8008 2.18134 16.2984 5.48557L16.919 6.10706C17.3862 6.57426 18.1481 6.57253 18.6179 6.10273C19.0869 5.63206 19.0886 4.87101 18.6214 4.40381Z"
        fill={name === 'wifi' ? COLOR.black30 : COLOR.brand}
      />
    </svg>
  )
}
const PcBatteryFullIcon = () => {
  return (
    <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.2 12.138L25.2 9.8L28 9.8L28 4.2L25.2 4.2L25.2 1.862C25.2 0.84 24.36 -1.59109e-07 23.338 -2.03782e-07L1.876 -1.14192e-06C0.84 -1.1872e-06 -3.67176e-08 0.839999 -8.13906e-08 1.862L-5.29957e-07 12.124C-5.75242e-07 13.16 0.84 14 1.862 14L23.338 14C24.36 14 25.2 13.16 25.2 12.138Z"
        fill="#333333"
      />
    </svg>
  )
}

const PcBatteryHalfIcon = () => {
  return (
    <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.8 14L1.4 14C0.63 14 -5.84421e-07 13.37 -5.50763e-07 12.6L-6.11959e-08 1.4C-2.75382e-08 0.629999 0.630001 -1.19638e-06 1.4 -1.16272e-06L23.8 -1.83588e-07C24.57 -1.4993e-07 25.2 0.63 25.2 1.4L25.2 4.2L28 4.2L28 9.8L25.2 9.8L25.2 12.6C25.2 13.37 24.57 14 23.8 14ZM22.4 11.2L22.4 2.8L14 2.8L14 11.2L22.4 11.2Z"
        fill="#333333"
      />
    </svg>
  )
}

const PcBatteryZeroIcon = () => {
  return (
    <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.8 14L1.4 14C0.63 14 -5.84421e-07 13.37 -5.50763e-07 12.6L-6.11959e-08 1.4C-2.75382e-08 0.629999 0.630001 -1.19638e-06 1.4 -1.16272e-06L23.8 -1.83588e-07C24.57 -1.4993e-07 25.2 0.63 25.2 1.4L25.2 4.2L28 4.2L28 9.8L25.2 9.8L25.2 12.6C25.2 13.37 24.57 14 23.8 14ZM22.4 11.2L22.4 2.8L2.8 2.8L2.8 11.2L22.4 11.2Z"
        fill="#B3B3B3"
      />
      <path
        d="M12.5951 8.2603L14.7371 10.3883L15.9971 9.1423L13.8551 7.0003L15.9831 4.8583L14.7371 3.6123L12.5951 5.7403L10.4671 3.6123L9.22107 4.8723L11.3491 7.0003L9.20707 9.1283L10.4671 10.3883L12.5951 8.2603Z"
        fill="#B3B3B3"
      />
    </svg>
  )
}

const MoBatteryFullIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8207 6.7792L12.8207 5.61021L14.2207 5.61021L14.2207 2.8102L12.8207 2.8102L12.8207 1.6412C12.8207 1.1302 12.4007 0.710205 11.8897 0.710205L1.1587 0.710205C0.640703 0.710204 0.220703 1.1302 0.220703 1.6412L0.220703 6.7722C0.220703 7.2902 0.640703 7.7102 1.1517 7.7102L11.8897 7.7102C12.4007 7.7102 12.8207 7.2902 12.8207 6.7792Z"
        fill="#333333"
      />
    </svg>
  )
}

const MoBatteryHalfIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1207 7.7102L0.920703 7.7102C0.535703 7.7102 0.220703 7.3952 0.220703 7.0102L0.220703 1.4102C0.220703 1.0252 0.535703 0.710204 0.920703 0.710204L12.1207 0.710205C12.5057 0.710205 12.8207 1.02521 12.8207 1.41021L12.8207 2.8102L14.2207 2.81021L14.2207 5.6102L12.8207 5.6102L12.8207 7.0102C12.8207 7.3952 12.5057 7.7102 12.1207 7.7102ZM11.4207 6.3102L11.4207 2.1102L7.2207 2.1102L7.2207 6.3102L11.4207 6.3102Z"
        fill="#333333"
      />
    </svg>
  )
}

const MoBatteryZeroIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1620_24246)">
        <path
          d="M13.7207 11.9602L1.7207 11.9602C1.3082 11.9602 0.970703 11.6227 0.970703 11.2102L0.970703 5.2102C0.970703 4.7977 1.3082 4.4602 1.7207 4.4602L13.7207 4.4602C14.1332 4.4602 14.4707 4.7977 14.4707 5.21021L14.4707 6.71021L15.9707 6.71021L15.9707 9.71021L14.4707 9.71021L14.4707 11.2102C14.4707 11.6227 14.1332 11.9602 13.7207 11.9602ZM12.9707 10.4602L12.9707 5.9602L2.4707 5.9602L2.4707 10.4602L12.9707 10.4602Z"
          fill="#B3B3B3"
        />
        <path
          d="M7.69703 8.88575L8.84453 10.0258L9.51953 9.35825L8.37203 8.21075L9.51203 7.06325L8.84453 6.39575L7.69703 7.53575L6.55703 6.39575L5.88953 7.07075L7.02953 8.21075L5.88203 9.35075L6.55703 10.0258L7.69703 8.88575Z"
          fill="#B3B3B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1620_24246">
          <rect width="16" height="16" fill="white" transform="translate(0.470703 0.210205)" />
        </clipPath>
      </defs>
    </svg>
  )
}

const ArrowIcon = (props: SvgPropsType) => {
  const { rotate, name, color, width, height } = props
  return (
    <>
      {name === 'reverse_arrow' && (
        <svg
          width={width ?? '22'}
          height={height ?? '21'}
          viewBox="0 0 22 21"
          style={{transform: `rotate(${rotate ?? 0}deg)`}}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.9293 20.4613L11 20.532L11.0707 20.4613L12.1199 19.4122L12.1906 19.3414L12.1199 19.2707L4.09388 11.2447H21H21.1V11.1447V9.63653V9.53653H21H4.09388L12.1199 1.51052L12.1906 1.43981L12.1199 1.36909L11.0707 0.319914L11 0.249204L10.9293 0.319914L0.929289 10.3199L0.858579 10.3906L0.929289 10.4613L10.9293 20.4613Z"
            fill="black"
            stroke="black"
            strokeWidth="0.2"
          />
        </svg>
      )}
      {name === 'arrow' && (
        <svg
          width={width ?? '10'}
          height={height ?? '18'}
          viewBox="0 0 10 18"
          style={{transform: `rotate(${rotate ?? 0}deg)`}}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 9.96094L2.01943 18.9609L0.5 17.3484L7.49647 9.96094L0.535334 2.57344L2.05477 0.960937L10.5 9.96094Z"
            fill={color || '#CCCCCC'}
          />
        </svg>
      )}
    </>
  )
}

const XIcon = (props: SvgPropsType) => {
  const { width, height } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse opacity="0.4" cx="14.0586" cy="14.9873" rx="14" ry="14" fill="black" />
      <path
        d="M8.22913 21.9873L7.05859 20.8168L12.8624 14.9873L7.05859 9.15784L8.22913 7.9873L14.0586 13.7911L19.8881 7.9873L21.0586 9.15784L15.2548 14.9873L21.0586 20.8168L19.8881 21.9873L14.0586 16.1835L8.22913 21.9873Z"
        fill="white"
      />
    </svg>
  )
}

const WifiPowerIcon = (props: SvgPropsType) => {
  const { wifipower } = props
  return (
    <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      {wifipower && (
        <>
          <path
            d="M9.54132 14.3151C10.7027 14.3151 11.6442 13.3736 11.6442 12.2122C11.6442 11.0509 10.7027 10.1094 9.54132 10.1094C8.37995 10.1094 7.43848 11.0509 7.43848 12.2122C7.43848 13.3736 8.37995 14.3151 9.54132 14.3151Z"
            fill="#646978"
          />
          {wifipower >= 2 && (
            <path
              d="M14.57 7.14655C14.5388 7.11448 14.5059 7.08587 14.4738 7.0564L14.3793 6.96712C14.3637 6.95065 14.3464 6.93852 14.3265 6.92292C11.6073 4.45255 7.44585 4.5505 4.85066 7.14568L4.54641 7.45079L4.12515 7.87206C3.61201 8.3852 3.61461 9.22166 4.12862 9.73567C4.6435 10.2514 5.47995 10.2523 5.99223 9.73914L6.7186 9.01276C8.36898 7.36325 11.0535 7.36325 12.703 9.01189L13.2274 9.51984C13.7353 10.0278 14.564 10.0269 15.0745 9.5155C15.3216 9.26933 15.4576 8.94082 15.4585 8.5915C15.4594 8.24391 15.325 7.9154 15.078 7.67009L14.57 7.14655Z"
              fill="#646978"
            />
          )}
          {wifipower > 2 && (
            <path
              d="M18.1507 4.54675L17.7138 4.10988C17.7121 4.10815 17.7112 4.10555 17.7077 4.10468L17.3628 3.75797C17.3021 3.69816 17.2362 3.64615 17.1669 3.60108C12.7349 -0.289971 5.99387 -0.170353 1.70323 3.95733C1.68242 3.9764 1.65902 3.9894 1.63822 4.0102L0.849433 4.79985C0.381363 5.26706 0.383964 6.02724 0.854634 6.49791C1.32444 6.96771 2.08462 6.97118 2.55269 6.50224L3.34147 5.71432C3.34667 5.70739 3.35101 5.70132 3.35621 5.69699C6.82599 2.34509 12.3301 2.32429 15.8277 5.62851L16.4483 6.25C16.9155 6.71721 17.6774 6.71547 18.1472 6.24567C18.6161 5.775 18.6179 5.01395 18.1507 4.54675Z"
              fill="#646978"
            />
          )}
        </>
      )}
    </svg>
  )
}

const HomeDeviceInfoReloadIcon = (props: SvgPropsType) => {
  const { width, height, color } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5559 3.03516C15.7434 1.22266 13.2559 0.0976562 10.4934 0.0976562C4.96836 0.0976562 0.505859 4.57266 0.505859 10.0977C0.505859 15.6227 4.96836 20.0977 10.4934 20.0977C15.1559 20.0977 19.0434 16.9102 20.1559 12.5977H17.5559C16.5309 15.5102 13.7559 17.5977 10.4934 17.5977C6.35586 17.5977 2.99336 14.2352 2.99336 10.0977C2.99336 5.96016 6.35586 2.59766 10.4934 2.59766C12.5684 2.59766 14.4184 3.46016 15.7684 4.82266L11.7434 8.84766H20.4934V0.0976562L17.5559 3.03516Z"
        fill={color ?? '#55BC7E'}
      />
    </svg>
  )
}

const LocationSoundIcon = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 5.83641L0.5 11.8364H4.5L9.5 16.8364L9.5 0.836406L4.5 5.83641L0.5 5.83641ZM14 8.83641C14 7.06641 12.98 5.54641 11.5 4.80641L11.5 12.8564C12.98 12.1264 14 10.6064 14 8.83641ZM11.5 0.0664063V2.12641C14.39 2.98641 16.5 5.66641 16.5 8.83641C16.5 12.0064 14.39 14.6864 11.5 15.5464L11.5 17.6064C15.51 16.6964 18.5 13.1164 18.5 8.83641C18.5 4.55641 15.51 0.976406 11.5 0.0664063Z"
        fill={color}
      />
    </svg>
  )
}

const LocationReloadIcon = (props: SvgPropsType) => {
  const { width, height } = props
  return (
    <svg
      width={width ?? '24'}
      height={height ?? '24'}
      viewBox={`0 0 ${Number(width) + 1 ?? '25'} ${Number(height) + 1 ?? '25'}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width={width ?? '24'}
        height={height ?? '24'}
        rx="16"
        fill="#55BC7E"
        id={'arrow_hover'}
      />
      {width === '32' ? (
        <path
          d="M21.8802 10.1159C20.3698 8.60547 18.2969 7.66797 15.9948 7.66797C11.3906 7.66797 7.67188 11.3971 7.67188 16.0013C7.67188 20.6055 11.3906 24.3346 15.9948 24.3346C19.8802 24.3346 23.1198 21.6784 24.0469 18.0846H21.8802C21.026 20.5117 18.7135 22.2513 15.9948 22.2513C12.5469 22.2513 9.74479 19.4492 9.74479 16.0013C9.74479 12.5534 12.5469 9.7513 15.9948 9.7513C17.724 9.7513 19.2656 10.4701 20.3906 11.6055L17.0365 14.9596H24.3281V7.66797L21.8802 10.1159Z"
          fill="white"
        />
      ) : (
        <>
          <rect
            x="0.5"
            y="0.839844"
            width="24"
            height="24"
            rx="12"
            fill="#55BC7E"
            id={'arrow_hover'}
          />
          <path
            d="M16.7364 8.59954C15.6482 7.51136 14.1548 6.83594 12.4962 6.83594C9.17917 6.83594 6.5 9.52262 6.5 12.8397C6.5 16.1568 9.17917 18.8434 12.4962 18.8434C15.2955 18.8434 17.6295 16.9297 18.2974 14.3406H16.7364C16.121 16.0892 14.455 17.3425 12.4962 17.3425C10.0122 17.3425 7.99343 15.3237 7.99343 12.8397C7.99343 10.3556 10.0122 8.33688 12.4962 8.33688C13.742 8.33688 14.8527 8.8547 15.6632 9.67271L13.2467 12.0892H18.5V6.83594L16.7364 8.59954Z"
            fill="white"
          />
        </>
      )}
    </svg>
  )
}

const LocationLockIcon = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1823_20918)">
        <path
          d="M12.5 8.31641C10.29 8.31641 8.5 10.1064 8.5 12.3164C8.5 14.5264 10.29 16.3164 12.5 16.3164C14.71 16.3164 16.5 14.5264 16.5 12.3164C16.5 10.1064 14.71 8.31641 12.5 8.31641ZM21.44 11.3164C20.98 7.14641 17.67 3.83641 13.5 3.37641V1.31641H11.5V3.37641C7.33 3.83641 4.02 7.14641 3.56 11.3164H1.5V13.3164H3.56C4.02 17.4864 7.33 20.7964 11.5 21.2564V23.3164H13.5V21.2564C17.67 20.7964 20.98 17.4864 21.44 13.3164H23.5V11.3164H21.44ZM12.5 19.3164C8.63 19.3164 5.5 16.1864 5.5 12.3164C5.5 8.44641 8.63 5.31641 12.5 5.31641C16.37 5.31641 19.5 8.44641 19.5 12.3164C19.5 16.1864 16.37 19.3164 12.5 19.3164Z"
          fill="#808080"
        />
      </g>
      <defs>
        <clipPath id="clip0_1823_20918">
          <rect width="24" height="24" fill="white" transform="translate(0.5 0.316406)" />
        </clipPath>
      </defs>
    </svg>
  )
}

const LocationTurnOffAttempt = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.25 13.3203C4.25 12.63 4.80964 12.0703 5.5 12.0703H15.5C16.1904 12.0703 16.75 12.63 16.75 13.3203V17.5703H4.25V13.3203Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="1.5"
      />
      <line x1="0.5" y1="17.5703" x2="20.5" y2="17.5703" stroke="#808080" strokeWidth="1.5" />
      <path
        d="M10.0001 2.72022L10.0001 8.71565L8.45399 7.16957L8.45399 7.16956L8.45333 7.16891C8.35991 7.07721 8.24061 7.02251 8.11346 7.01945C7.98558 7.01638 7.858 7.06574 7.74947 7.16724L7.74944 7.1672L7.74706 7.16957C7.55189 7.36479 7.55189 7.68126 7.74706 7.87647L7.74707 7.87648L10.1448 10.2743C10.3121 10.4569 10.6443 10.4798 10.8525 10.2768L10.8525 10.2768L10.8534 10.2759L13.2529 7.87648L13.2529 7.87648C13.4481 7.68126 13.4481 7.36479 13.2529 7.16957L13.2529 7.16956C13.0577 6.97438 12.7412 6.97438 12.546 7.16956L12.546 7.16957L10.9999 8.71565L10.9999 2.72022C10.9999 2.44413 10.7761 2.22031 10.5 2.22031C10.2239 2.22031 10.0001 2.44413 10.0001 2.72022Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.2"
      />
    </svg>
  )
}

const LocationFirstLock = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1823_11619)">
        <path
          d="M18.5 8.31641H17.5V6.31641C17.5 3.55641 15.26 1.31641 12.5 1.31641C9.74 1.31641 7.5 3.55641 7.5 6.31641V8.31641H6.5C5.4 8.31641 4.5 9.21641 4.5 10.3164V20.3164C4.5 21.4164 5.4 22.3164 6.5 22.3164H18.5C19.6 22.3164 20.5 21.4164 20.5 20.3164V10.3164C20.5 9.21641 19.6 8.31641 18.5 8.31641ZM12.5 17.3164C11.4 17.3164 10.5 16.4164 10.5 15.3164C10.5 14.2164 11.4 13.3164 12.5 13.3164C13.6 13.3164 14.5 14.2164 14.5 15.3164C14.5 16.4164 13.6 17.3164 12.5 17.3164ZM15.6 8.31641H9.4V6.31641C9.4 4.60641 10.79 3.21641 12.5 3.21641C14.21 3.21641 15.6 4.60641 15.6 6.31641V8.31641Z"
          fill="#808080"
        />
      </g>
      <defs>
        <clipPath id="clip0_1823_11619">
          <rect width="24" height="24" fill="white" transform="translate(0.5 0.316406)" />
        </clipPath>
      </defs>
    </svg>
  )
}

const SettingUnlockIcon = () => {
  return (
    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.49972 14.5893C8.44258 14.5893 9.21401 13.8179 9.21401 12.875C9.21401 11.9321 8.44258 11.1607 7.49972 11.1607C6.55686 11.1607 5.78544 11.9321 5.78544 12.875C5.78544 13.8179 6.55686 14.5893 7.49972 14.5893ZM12.6426 6.875H11.7854L11.7854 5.16071C11.7854 2.795 9.86544 0.875 7.49972 0.875C5.13401 0.875 3.21401 2.795 3.21401 5.16071L4.84258 5.16071C4.84258 3.695 6.03401 2.50357 7.49972 2.50357C8.96544 2.50357 10.1569 3.695 10.1569 5.16071L10.1569 6.875L2.35686 6.875C1.41401 6.875 0.642578 7.64643 0.642578 8.58929L0.642578 17.1607C0.642578 18.1036 1.41401 18.875 2.35686 18.875L12.6426 18.875C13.5854 18.875 14.3569 18.1036 14.3569 17.1607V8.58929C14.3569 7.64643 13.5854 6.875 12.6426 6.875ZM12.6426 17.1607L2.35686 17.1607L2.35686 8.58929L12.6426 8.58929V17.1607Z"
        fill="black"
      />
    </svg>
  )
}
const SettingFaqIcon = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 18.875C8.255 18.875 7.085 18.6386 5.99 18.1658C4.895 17.6936 3.9425 17.0525 3.1325 16.2425C2.3225 15.4325 1.6814 14.48 1.2092 13.385C0.7364 12.29 0.5 11.12 0.5 9.875C0.5 8.63 0.7364 7.46 1.2092 6.365C1.6814 5.27 2.3225 4.3175 3.1325 3.5075C3.9425 2.6975 4.895 2.0561 5.99 1.5833C7.085 1.1111 8.255 0.875 9.5 0.875C10.745 0.875 11.915 1.1111 13.01 1.5833C14.105 2.0561 15.0575 2.6975 15.8675 3.5075C16.6775 4.3175 17.3186 5.27 17.7908 6.365C18.2636 7.46 18.5 8.63 18.5 9.875C18.5 11.12 18.2636 12.29 17.7908 13.385C17.3186 14.48 16.6775 15.4325 15.8675 16.2425C15.0575 17.0525 14.105 17.6936 13.01 18.1658C11.915 18.6386 10.745 18.875 9.5 18.875ZM9.5 17.075C11.51 17.075 13.2125 16.3775 14.6075 14.9825C16.0025 13.5875 16.7 11.885 16.7 9.875C16.7 7.865 16.0025 6.1625 14.6075 4.7675C13.2125 3.3725 11.51 2.675 9.5 2.675C7.49 2.675 5.7875 3.3725 4.3925 4.7675C2.9975 6.1625 2.3 7.865 2.3 9.875C2.3 11.885 2.9975 13.5875 4.3925 14.9825C5.7875 16.3775 7.49 17.075 9.5 17.075Z"
        fill="black"
      />
      <path
        d="M8.34416 15.0179H10.6558V8.17773L8.34416 8.17773L8.34416 15.0179ZM9.5 7.1388C10.2662 7.1388 10.7857 6.66536 10.7857 5.92889C10.7857 5.20558 10.2662 4.73214 9.5 4.73214C8.72078 4.73214 8.21429 5.20558 8.21429 5.92889C8.21429 6.66536 8.72078 7.1388 9.5 7.1388Z"
        fill="black"
      />
    </svg>
  )
}
const SettingAnnouncementIcon = () => {
  return (
    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 15.675L0.5 13.875H2.3L2.3 7.575C2.3 6.33 2.675 5.2236 3.425 4.2558C4.175 3.2886 5.15 2.655 6.35 2.355V1.725C6.35 1.35 6.4814 1.0314 6.7442 0.7692C7.0064 0.5064 7.325 0.375 7.7 0.375C8.075 0.375 8.3936 0.5064 8.6558 0.7692C8.9186 1.0314 9.05 1.35 9.05 1.725V2.355C10.25 2.655 11.225 3.2886 11.975 4.2558C12.725 5.2236 13.1 6.33 13.1 7.575V13.875H14.9V15.675L0.5 15.675ZM7.7 18.375C7.205 18.375 6.7814 18.1989 6.4292 17.8467C6.0764 17.4939 5.9 17.07 5.9 16.575H9.5C9.5 17.07 9.3239 17.4939 8.9717 17.8467C8.6189 18.1989 8.195 18.375 7.7 18.375ZM4.1 13.875L11.3 13.875V7.575C11.3 6.585 10.9475 5.7375 10.2425 5.0325C9.5375 4.3275 8.69 3.975 7.7 3.975C6.71 3.975 5.8625 4.3275 5.1575 5.0325C4.4525 5.7375 4.1 6.585 4.1 7.575V13.875Z"
        fill="black"
      />
    </svg>
  )
}
const SettingSignOutIcon = () => {
  return (
    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 4.37344L12.731 5.64244L15.053 7.97344L5.9 7.97344L5.9 9.77344L15.053 9.77344L12.731 12.0954L14 13.3734L18.5 8.87344L14 4.37344ZM2.3 2.57344L9.5 2.57344V0.773438L2.3 0.773438C1.31 0.773438 0.5 1.58344 0.5 2.57344L0.5 15.1734C0.5 16.1634 1.31 16.9734 2.3 16.9734H9.5V15.1734L2.3 15.1734L2.3 2.57344Z"
        fill="black"
      />
    </svg>
  )
}

const LoginErrorIcon = () => {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5346 15.6819L9.81059 2.24191L2.08661 15.6819L17.5346 15.6819ZM10.914 1.60191C10.4236 0.748581 9.19757 0.74858 8.70716 1.60191L0.983187 15.0419C0.492775 15.8952 1.10579 16.9619 2.08661 16.9619H17.5346C18.5154 16.9619 19.1284 15.8952 18.638 15.0419L10.914 1.60191Z"
        fill={`${COLOR.red80}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.81059 2.24191L2.08661 15.6819L17.5346 15.6819L9.81059 2.24191ZM9.81154 2.6431L2.43318 15.4817L17.1899 15.4817L9.81154 2.6431ZM8.53472 1.50206C9.10202 0.514936 10.5211 0.514938 11.0884 1.50206L18.8123 14.9421C19.3786 15.9274 18.6717 17.1617 17.5355 17.1617H2.08757C0.951375 17.1617 0.244496 15.9274 0.810742 14.9421L8.53472 1.50206ZM8.70716 1.60191C9.19757 0.74858 10.4236 0.748581 10.914 1.60191L18.638 15.0419C19.1284 15.8952 18.5154 16.9619 17.5346 16.9619H2.08661C1.10579 16.9619 0.492775 15.8952 0.983187 15.0419L8.70716 1.60191Z"
        fill={`${COLOR.red80}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.56254 5.96094C9.97675 5.96094 10.3125 6.29672 10.3125 6.71094L10.3125 10.2109C10.3125 10.6252 9.97675 10.9609 9.56254 10.9609C9.14832 10.9609 8.81254 10.6252 8.81254 10.2109L8.81254 6.71094C8.81254 6.29672 9.14832 5.96094 9.56254 5.96094Z"
        fill={`${COLOR.red80}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.56254 11.9609C9.97675 11.9609 10.3125 12.2967 10.3125 12.7109L10.3125 13.2109C10.3125 13.6252 9.97675 13.9609 9.56254 13.9609C9.14832 13.9609 8.81254 13.6252 8.81254 13.2109L8.81254 12.7109C8.81254 12.2967 9.14832 11.9609 9.56254 11.9609Z"
        fill={`${COLOR.red80}`}
      />
    </svg>
  )
}

const PinEyesIcon = (props: SvgPropsType) => {
  const { name } = props
  return (
    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d={
          name === 'pin_Input_eyes'
            ? 'M9.56592 0.363281C5.47501 0.363281 1.98137 2.90783 0.565918 6.49965C1.98137 10.0915 5.47501 12.636 9.56592 12.636C13.6568 12.636 17.1505 10.0915 18.5659 6.49965C17.1505 2.90783 13.6568 0.363281 9.56592 0.363281ZM9.56592 10.5906C7.30774 10.5906 5.47501 8.75783 5.47501 6.49965C5.47501 4.24146 7.30774 2.40874 9.56592 2.40874C11.8241 2.40874 13.6568 4.24146 13.6568 6.49965C13.6568 8.75783 11.8241 10.5906 9.56592 10.5906ZM9.56592 4.0451C8.20774 4.0451 7.11137 5.14146 7.11137 6.49965C7.11137 7.85783 8.20774 8.95419 9.56592 8.95419C10.9241 8.95419 12.0205 7.85783 12.0205 6.49965C12.0205 5.14146 10.9241 4.0451 9.56592 4.0451Z'
            : 'M9.50409 3.99687C11.7633 3.99687 13.5969 5.83043 13.5969 8.08964C13.5969 8.6217 13.4904 9.12102 13.3022 9.58759L15.6924 11.9778C16.9284 10.9464 17.9025 9.61215 18.5 8.08964C17.0839 4.49619 13.5887 1.95049 9.49591 1.95049C8.34993 1.95049 7.25307 2.15513 6.23806 2.52347L8.00614 4.29155C8.47272 4.10328 8.97203 3.99687 9.50409 3.99687ZM1.31855 1.76222L3.18486 3.62852L3.56139 4.00506C2.20259 5.06099 1.13847 6.4689 0.5 8.08964C1.9161 11.6831 5.41132 14.2288 9.50409 14.2288C10.7729 14.2288 11.9843 13.9832 13.0894 13.5412L13.4332 13.885L15.8315 16.2752L16.8711 15.2356L2.35812 0.722656L1.31855 1.76222ZM5.84516 6.28882L7.11392 7.55758C7.07299 7.72948 7.04843 7.90956 7.04843 8.08964C7.04843 9.44844 8.14529 10.5453 9.50409 10.5453C9.68418 10.5453 9.86426 10.5207 10.0362 10.4798L11.3049 11.7486C10.7565 12.0187 10.1508 12.1824 9.50409 12.1824C7.24488 12.1824 5.41132 10.3489 5.41132 8.08964C5.41132 7.44298 5.57503 6.83725 5.84516 6.28882ZM9.37313 5.65035L11.9516 8.2288L11.9679 8.09783C11.9679 6.73903 10.8711 5.64217 9.51228 5.64217L9.37313 5.65035Z'
        }
        fill="#afafaf"
      />
    </svg>
  )
}

const ExplorerImageIcon = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5 20.434V4.87847C22.5 3.65625 21.5 2.65625 20.2778 2.65625H4.72222C3.5 2.65625 2.5 3.65625 2.5 4.87847V20.434C2.5 21.6562 3.5 22.6562 4.72222 22.6562H20.2778C21.5 22.6562 22.5 21.6562 22.5 20.434ZM8.61111 14.3229L11.3889 17.6674L15.2778 12.6562L20.2778 19.3229H4.72222L8.61111 14.3229Z"
        fill={color ?? '#68967A'}
      />
    </svg>
  )
}
const ExplorerAudioIcon = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4997 2.65625V13.9917C11.8135 13.5962 11.0226 13.352 10.1736 13.352C7.60331 13.352 5.52148 15.4338 5.52148 18.0041C5.52148 20.5744 7.60331 22.6562 10.1736 22.6562C12.7439 22.6562 14.8257 20.5744 14.8257 18.0041V6.3738H19.4779V2.65625H12.4997Z"
        fill={color ?? '#94725E'}
      />
    </svg>
  )
}
const ExplorerDocumentIcon = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5 2.65625H6.5C5.4 2.65625 4.51 3.55625 4.51 4.65625L4.5 20.6562C4.5 21.7563 5.39 22.6562 6.49 22.6562H18.5C19.6 22.6562 20.5 21.7563 20.5 20.6562V8.65625L14.5 2.65625ZM16.5 18.6562H8.5V16.6562H16.5V18.6562ZM16.5 14.6562H8.5V12.6562H16.5V14.6562ZM13.5 9.65625V4.15625L19 9.65625H13.5Z"
        fill={color ?? '#7E5E94'}
      />
    </svg>
  )
}
const ExplorerDownIcon = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.7352 9.71507H16.0294V2.65625H8.97053V9.71507H4.26465L12.4999 17.9504L20.7352 9.71507ZM4.26465 20.3033V22.6562H20.7352V20.3033H4.26465Z"
        fill={color ?? '#3592AF'}
      />
    </svg>
  )
}
const ExplorerApkIcon = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.59672 9.5L6 13.1H7.54286L6.93002 9.5H6.59672Z" fill={color ?? '#808080'} />
      <path d="M13.329 9.22852H11.7861V10.7714H13.329V9.22852Z" fill={color ?? '#808080'} />
      <path
        d="M20.4 1H4.2C2.71371 1 1.5 2.21371 1.5 3.7V19.9C1.5 21.3863 2.71371 22.6 4.2 22.6H20.4C21.8863 22.6 23.1 21.3863 23.1 19.9V3.7C23.1 2.21371 21.8863 1 20.4 1ZM7.93886 15.8526L7.64057 14.2429V14.2634H5.77886L5.48057 15.8474H3.95829L5.66057 7.74743H7.88229L9.58457 15.8474H7.944L7.93886 15.8526ZM15.0463 10.9926C15.0463 11.4503 14.892 11.836 14.5834 12.1446C14.2749 12.4531 13.8891 12.6074 13.4314 12.6074H11.8166V15.8371H10.2017V7.76286H13.4314C13.8891 7.76286 14.2749 7.91714 14.5834 8.22571C14.892 8.53429 15.0463 8.92 15.0463 9.37772V10.9926ZM19.0526 15.8526L17.7669 12.2423L17.16 13.2709V15.8526H15.6429V7.75257H17.16V11.1674L19.0937 7.75257H20.6109L18.8006 10.7251L20.6366 15.8526H19.0474H19.0526Z"
        fill={color ?? '#808080'}
      />
    </svg>
  )
}

const ExplorerDefaultIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 2">
        <g id="Group 2215">
          <path
            id="Vector"
            d="M5.66 22.6C5.066 22.6 4.5584 22.384 4.1372 21.9628C3.716 21.5416 3.5 21.034 3.5 20.44V3.16C3.5 2.566 3.716 2.0584 4.1372 1.6372C4.5584 1.216 5.066 1 5.66 1H14.3L20.78 7.48V20.44C20.78 21.034 20.564 21.5416 20.1428 21.9628C19.7216 22.384 19.214 22.6 18.62 22.6H5.66ZM13.22 8.56V3.16H5.66V20.44H18.62V8.56H13.22Z"
            fill="#999999"
          />
        </g>
      </g>
    </svg>
  )
}

const ExplorerVideoIcon = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0556 10.9922V7.1033C18.0556 6.49219 17.5556 5.99219 16.9444 5.99219H3.61111C3 5.99219 2.5 6.49219 2.5 7.1033V18.2144C2.5 18.8255 3 19.3255 3.61111 19.3255H16.9444C17.5556 19.3255 18.0556 18.8255 18.0556 18.2144V14.3255L22.5 18.77V6.54774L18.0556 10.9922Z"
        fill={color ?? '#966868'}
      />
    </svg>
  )
}

const ExplorerDeleteData = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5 19.4219C6.5 20.5219 7.4 21.4219 8.5 21.4219H16.5C17.6 21.4219 18.5 20.5219 18.5 19.4219V7.42188L6.5 7.42188L6.5 19.4219ZM8.96 12.3019L10.37 10.8919L12.5 13.0119L14.62 10.8919L16.03 12.3019L13.91 14.4219L16.03 16.5419L14.62 17.9519L12.5 15.8319L10.38 17.9519L8.97 16.5419L11.09 14.4219L8.96 12.3019ZM16 4.42188L15 3.42188L10 3.42188L9 4.42188L5.5 4.42188L5.5 6.42188L19.5 6.42188V4.42188H16Z"
        fill="black"
      />
    </svg>
  )
}
const ViewUserGuideIcon = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.955 15.068C9.27 15.068 9.5364 14.9591 9.7542 14.7413C9.9714 14.5241 10.08 14.258 10.08 13.943C10.08 13.628 9.9714 13.3619 9.7542 13.1447C9.5364 12.9269 9.27 12.818 8.955 12.818C8.64 12.818 8.3736 12.9269 8.1558 13.1447C7.9386 13.3619 7.83 13.628 7.83 13.943C7.83 14.258 7.9386 14.5241 8.1558 14.7413C8.3736 14.9591 8.64 15.068 8.955 15.068ZM8.145 11.603H9.81C9.81 11.108 9.8664 10.718 9.9792 10.433C10.0914 10.148 10.41 9.75797 10.935 9.26297C11.325 8.87297 11.6325 8.50157 11.8575 8.14877C12.0825 7.79657 12.195 7.37297 12.195 6.87797C12.195 6.03797 11.8875 5.39297 11.2725 4.94297C10.6575 4.49297 9.93 4.26797 9.09 4.26797C8.235 4.26797 7.5414 4.49297 7.0092 4.94297C6.4764 5.39297 6.105 5.93297 5.895 6.56297L7.38 7.14797C7.455 6.87797 7.6239 6.58547 7.8867 6.27047C8.1489 5.95547 8.55 5.79797 9.09 5.79797C9.57 5.79797 9.93 5.92907 10.17 6.19127C10.41 6.45407 10.53 6.74297 10.53 7.05797C10.53 7.35797 10.44 7.63907 10.26 7.90127C10.08 8.16407 9.855 8.40797 9.585 8.63297C8.925 9.21797 8.52 9.66047 8.37 9.96047C8.22 10.2605 8.145 10.808 8.145 11.603ZM9 18.668C7.755 18.668 6.585 18.4316 5.49 17.9588C4.395 17.4866 3.4425 16.8455 2.6325 16.0355C1.8225 15.2255 1.1814 14.273 0.7092 13.178C0.2364 12.083 0 10.913 0 9.66797C0 8.42297 0.2364 7.25297 0.7092 6.15797C1.1814 5.06297 1.8225 4.11047 2.6325 3.30047C3.4425 2.49047 4.395 1.84907 5.49 1.37627C6.585 0.904069 7.755 0.667969 9 0.667969C10.245 0.667969 11.415 0.904069 12.51 1.37627C13.605 1.84907 14.5575 2.49047 15.3675 3.30047C16.1775 4.11047 16.8186 5.06297 17.2908 6.15797C17.7636 7.25297 18 8.42297 18 9.66797C18 10.913 17.7636 12.083 17.2908 13.178C16.8186 14.273 16.1775 15.2255 15.3675 16.0355C14.5575 16.8455 13.605 17.4866 12.51 17.9588C11.415 18.4316 10.245 18.668 9 18.668ZM9 16.868C11.01 16.868 12.7125 16.1705 14.1075 14.7755C15.5025 13.3805 16.2 11.678 16.2 9.66797C16.2 7.65797 15.5025 5.95547 14.1075 4.56047C12.7125 3.16547 11.01 2.46797 9 2.46797C6.99 2.46797 5.2875 3.16547 3.8925 4.56047C2.4975 5.95547 1.8 7.65797 1.8 9.66797C1.8 11.678 2.4975 13.3805 3.8925 14.7755C5.2875 16.1705 6.99 16.868 9 16.868Z"
        fill="black"
      />
    </svg>
  )
}
const ImageScaleIcon = () => {
  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.4" x="0.558594" y="0.592773" width="32" height="32" rx="4" fill="black" />
      <g clipPath="url(#clip0_1281_257078)">
        <path
          d="M8.14714 26.5928C7.70269 26.5928 7.3138 26.4261 6.98047 26.0928C6.64714 25.7594 6.48047 25.3706 6.48047 24.9261V20.1483H8.14714V24.9261H12.9249V26.5928H8.14714ZM20.036 26.5928V24.9261H24.8138V20.1483H26.4805V24.9261C26.4805 25.3706 26.3138 25.7594 25.9805 26.0928C25.6471 26.4261 25.2582 26.5928 24.8138 26.5928H20.036ZM6.48047 13.0372V8.25944C6.48047 7.815 6.64714 7.42611 6.98047 7.09277C7.3138 6.75944 7.70269 6.59277 8.14714 6.59277H12.9249V8.25944H8.14714V13.0372H6.48047ZM24.8138 13.0372V8.25944H20.036V6.59277H24.8138C25.2582 6.59277 25.6471 6.75944 25.9805 7.09277C26.3138 7.42611 26.4805 7.815 26.4805 8.25944V13.0372H24.8138Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1281_257078">
          <rect width="24" height="24" fill="white" transform="translate(4.48047 4.59277)" />
        </clipPath>
      </defs>
    </svg>
  )
}
const ImageReloadIcon = (props: SvgPropsType) => {
  const { width, height } = props
  return (
    <svg
      width={width ?? 56}
      height={height ?? 56}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.7" cx="28" cy="28" r="28" fill="black" />
      <g clipPath="url(#clip0_3199_314973)">
        <path
          d="M22.1185 20.958L13.5762 29.5135L22.1317 38.0559L30.6873 29.5135L22.1185 20.958ZM17.3069 29.5135L22.1317 24.6887L26.9434 29.5135L22.1185 34.3384L17.3069 29.5135ZM37.9641 21.2612C35.6572 18.941 32.612 17.781 29.5799 17.781V13.5098L23.9905 19.0992L29.5799 24.6887V20.4175C31.9396 20.4175 34.2993 21.3139 36.1054 23.1199C39.7042 26.7188 39.7042 32.5719 36.1054 36.1708C34.2993 37.9768 31.9396 38.8732 29.5799 38.8732C28.3012 38.8732 27.0225 38.5964 25.8361 38.0691L23.8718 40.0333C25.6515 41.0088 27.6157 41.5098 29.5799 41.5098C32.612 41.5098 35.6572 40.3497 37.9641 38.0295C42.6044 33.4024 42.6044 25.8883 37.9641 21.2612Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3199_314973">
          <rect width="32" height="32" fill="white" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  )
}
const HorizontalArrowIcon = (props: SvgPropsType) => {
  const { width, height, name, opacity } = props
  return (
    <svg
      width={width ?? 56}
      height={height ?? 56}
      viewBox="0 0 57 57"
      fill={COLOR.black100}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28.9707" cy="28.2312" r="28" fill={COLOR.black100} />
      {name === 'right_arrow' && (
        <path
          d="M36.7484 28.2312L23.5564 42.2312L21.1929 39.7229L32.0763 28.2312L21.2478 16.7395L23.6114 14.2312L36.7484 28.2312Z"
          opacity={opacity}
          fill="white"
        />
      )}
      {name === 'left_arrow' && (
        <path
          d="M21.193 28.2312L34.385 14.2312L36.7485 16.7395L25.8651 28.2312L36.6936 39.7229L34.33 42.2312L21.193 28.2312Z"
          opacity={opacity}
          fill="white"
        />
      )}
    </svg>
  )
}

const LogoIcon = (props: SvgPropsType) => {
  const { width, height } = props
  return (
    <svg
      width={width ?? 28}
      height={height ?? 24}
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.113 0.330571C20.4869 0.609442 20.7264 1.04732 20.7533 1.52923C20.7655 1.74205 20.7459 1.95976 20.6677 2.17992L20.5236 2.57621L19.8516 4.42067C20.2719 4.565 20.6824 4.74113 21.0783 4.94906L21.5743 3.53024C21.6476 3.32721 21.677 3.12417 21.6721 2.92847C21.6721 1.36044 20.113 0.328125 20.113 0.328125V0.330571Z"
        fill="#CFE7CD"
      />
      <path
        d="M13.611 21.8598C13.3887 21.5687 13.1614 21.2899 12.9366 21.0257C12.8682 20.9474 12.7997 20.874 12.7313 20.7957H11.793L1.59319 20.7762C1.34394 20.7762 1.11913 20.715 0.913859 20.6196C0.505771 20.4288 0.200316 20.0741 0.0683594 19.6484C0.0683594 19.6484 0.302949 21.4097 1.86444 21.9968C1.92308 22.0213 1.98173 22.0433 2.04282 22.0604C2.04282 22.0604 2.04282 22.0604 2.04527 22.0604C2.187 22.102 2.3385 22.124 2.49734 22.124L11.1869 22.1411H11.5632H12.7386H13.8285C13.7576 22.0457 13.6868 21.9479 13.6135 21.8549L13.611 21.8598Z"
        fill="#CFE7CD"
      />
      <path
        d="M20.7551 1.53134C20.7282 1.04943 20.4887 0.611558 20.1148 0.332688C19.8558 0.141882 19.5357 0.0244623 19.1716 0.0244623L8.07745 0C7.36146 0 6.71146 0.457446 6.46953 1.1375L0.0989609 18.6158C-0.0281085 18.9705 -0.0281086 19.3301 0.0720807 19.6482C0.204037 20.0714 0.507049 20.4261 0.917581 20.6193C1.12285 20.7147 1.34766 20.7759 1.59691 20.7759L11.7967 20.7954H12.735C12.3978 20.4114 12.0557 20.0444 11.716 19.7118L10.9072 18.9216L10.8999 18.9143L10.8925 18.9069C9.24796 17.2606 8.34137 15.059 8.34137 12.7057C8.34137 10.3525 9.24796 8.14841 10.8925 6.50454C12.5371 4.85822 14.7242 3.95067 17.0481 3.95067C17.9766 3.95067 18.9052 4.10478 19.8143 4.40811C19.8289 4.41301 19.8411 4.4179 19.8558 4.42279L20.5278 2.57833L20.672 2.18204C20.7502 1.96188 20.7697 1.74416 20.7575 1.53134H20.7551ZM15.3277 1.58761L15.2007 2.00591C15.1616 2.13556 15.0247 2.24075 14.8952 2.24075H10.8901C10.7606 2.24075 10.6873 2.13556 10.7264 2.00591L10.8534 1.58761C10.8901 1.46529 11.0147 1.36989 11.1369 1.35766C11.1442 1.35766 11.1516 1.35277 11.1589 1.35277H15.164C15.186 1.35277 15.2031 1.36011 15.2202 1.365C15.3106 1.39191 15.3595 1.47997 15.3253 1.58761H15.3277Z"
        fill="url(#paint0_linear_3533_19578)"
      />
      <path
        d="M21.9702 7.73547C21.8603 7.62539 21.743 7.5251 21.6281 7.4248C21.2713 7.11168 20.8926 6.8426 20.4943 6.6151C20.0984 6.3876 19.6854 6.20413 19.2602 6.06225C18.5418 5.82252 17.7965 5.69531 17.0487 5.69531C15.2673 5.69531 13.4835 6.37537 12.1248 7.73792C9.40502 10.4606 9.40502 14.9543 12.1248 17.6745L12.9336 18.4647C13.3979 18.9197 13.8402 19.3967 14.263 19.8908C14.5147 20.1868 14.759 20.4877 14.9961 20.7959C15.1085 20.9427 15.2184 21.087 15.326 21.2362C15.9662 22.112 16.5429 23.0367 17.0463 24.0005C17.6352 22.8728 18.3243 21.8013 19.0989 20.7959C19.7318 19.974 20.4185 19.1936 21.1614 18.4647L21.9702 17.6745C23.952 15.6906 24.4823 12.7674 23.5757 10.2722C23.2385 9.34509 22.7082 8.47423 21.9702 7.73792V7.73547ZM17.1831 15.9768C17.1367 15.9768 17.0927 15.9842 17.0463 15.9842C16.5918 15.9842 16.1592 15.8937 15.7634 15.7322C14.5244 15.2258 13.6521 14.0101 13.6521 12.5888C13.6521 10.7125 15.172 9.19098 17.0463 9.19098C17.4031 9.19098 17.7476 9.24724 18.0702 9.34999C18.5222 9.49431 18.9328 9.7316 19.2822 10.0374C19.5315 10.2575 19.749 10.5144 19.9249 10.7982C19.9909 10.9058 20.052 11.0159 20.1057 11.1308C20.3159 11.5736 20.4381 12.0653 20.4381 12.5888C20.4381 14.4186 18.9914 15.9059 17.1831 15.9793V15.9768Z"
        fill="url(#paint1_linear_3533_19578)"
      />
      <path
        d="M26.1567 10.5917C25.7315 7.49965 23.5738 5.88269 23.4834 5.81664C23.305 5.68454 23.0557 5.72368 22.9238 5.90226C22.8627 5.98298 22.8407 6.07839 22.848 6.17379C22.8578 6.28632 22.9116 6.3915 23.0069 6.46489C23.0264 6.47957 24.9838 7.95954 25.3625 10.7042C25.3821 10.8412 25.4652 10.9513 25.58 11.0075C25.646 11.0393 25.7218 11.0565 25.8 11.0491C25.8048 11.0491 25.8097 11.0491 25.8146 11.0491C26.0345 11.0198 26.186 10.8167 26.1567 10.5966V10.5917Z"
        fill="url(#paint2_linear_3533_19578)"
      />
      <path
        d="M27.9942 10.15C27.3076 5.47032 23.994 3.63564 23.8522 3.55981C23.6568 3.45462 23.4148 3.52801 23.3098 3.72126C23.2047 3.91696 23.278 4.15914 23.471 4.26432C23.5028 4.28145 26.572 5.9987 27.2 10.2649C27.2318 10.4778 27.4248 10.627 27.6374 10.605C27.6448 10.605 27.6497 10.605 27.657 10.605C27.8769 10.5732 28.0284 10.3677 27.9967 10.15H27.9942Z"
        fill="url(#paint3_linear_3533_19578)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3533_19578"
          x1="14.5384"
          y1="-9.27612"
          x2="2.38356"
          y2="48.1342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#85C023" />
          <stop offset="0.5" stopColor="#057C66" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3533_19578"
          x1="17.0438"
          y1="22.8752"
          x2="17.0438"
          y2="-4.86753"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F18D00" />
          <stop offset="0.09" stopColor="#EE6904" />
          <stop offset="0.2" stopColor="#EB4908" />
          <stop offset="0.31" stopColor="#E92E0C" />
          <stop offset="0.43" stopColor="#E8190E" />
          <stop offset="0.57" stopColor="#E60B10" />
          <stop offset="0.74" stopColor="#E60211" />
          <stop offset="1" stopColor="#E60012" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3533_19578"
          x1="18.3493"
          y1="12.7052"
          x2="32.4712"
          y2="2.83163"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F18D00" />
          <stop offset="0.09" stopColor="#EE6904" />
          <stop offset="0.2" stopColor="#EB4908" />
          <stop offset="0.31" stopColor="#E92E0C" />
          <stop offset="0.43" stopColor="#E8190E" />
          <stop offset="0.57" stopColor="#E60B10" />
          <stop offset="0.74" stopColor="#E60211" />
          <stop offset="1" stopColor="#E60012" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3533_19578"
          x1="18.095"
          y1="12.3393"
          x2="32.2144"
          y2="2.46818"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F18D00" />
          <stop offset="0.09" stopColor="#EE6904" />
          <stop offset="0.2" stopColor="#EB4908" />
          <stop offset="0.31" stopColor="#E92E0C" />
          <stop offset="0.43" stopColor="#E8190E" />
          <stop offset="0.57" stopColor="#E60B10" />
          <stop offset="0.74" stopColor="#E60211" />
          <stop offset="1" stopColor="#E60012" />
        </linearGradient>
      </defs>
    </svg>
  )
}

const CameraCam = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.2333 16.7578L14.5 18.3578L36.7667 40.6245L38.5 38.8911L16.2333 16.7578Z"
        fill={color ?? 'white'}
      />
      <path
        d="M18.6331 20.2246C17.9665 20.2246 17.2998 20.8913 17.2998 21.5579V34.8913C17.2998 35.5579 17.9665 36.2246 18.6331 36.2246H34.6331C34.8998 36.2246 35.1665 36.0913 35.4331 35.9579L19.6998 20.2246H18.6331Z"
        fill={color ?? 'white'}
      />
      <path
        d="M41.2993 34.2246V22.2246L35.966 26.2246V21.5579C35.966 20.8913 35.2993 20.2246 34.6327 20.2246H23.166L35.966 33.0246V30.2246L41.2993 34.2246Z"
        fill={color ?? 'white'}
      />
    </svg>
  )
}

const CameraMic = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.8333 27.7578H35.5667C35.5667 28.7445 35.3533 29.6645 34.9933 30.4911L36.6333 32.1311C37.38 30.8245 37.8333 29.3445 37.8333 27.7578ZM32.4733 27.9845C32.4733 27.9045 32.5 27.8378 32.5 27.7578V19.7578C32.5 17.5445 30.7133 15.7578 28.5 15.7578C26.2867 15.7578 24.5 17.5445 24.5 19.7578V19.9978L32.4733 27.9845ZM18.1933 17.0911L16.5 18.7845L24.5133 26.7978V27.7578C24.5133 29.9711 26.2867 31.7578 28.5 31.7578C28.7933 31.7578 29.0867 31.7178 29.3667 31.6511L31.58 33.8645C30.6333 34.3045 29.58 34.5578 28.5 34.5578C24.82 34.5578 21.4333 31.7578 21.4333 27.7578H19.1667C19.1667 32.3045 22.7933 36.0645 27.1667 36.7178V41.0911H29.8333V36.7178C31.0467 36.5445 32.1933 36.1178 33.22 35.5178L38.8067 41.0911L40.5 39.3978L18.1933 17.0911Z"
        fill={color ?? 'white'}
      />
    </svg>
  )
}

const CameraRotate = (props: SvgPropsType) => {
  const { color } = props
  return (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.9013 25.9576V23.1572H18.8267C20.759 19.8107 24.3716 17.5563 28.5022 17.5563C33.711 17.5563 38.0937 21.1409 39.3399 25.9576H42.2244C40.9222 19.5726 35.2793 14.7559 28.5022 14.7559C23.9235 14.7559 19.8488 16.9682 17.3004 20.3707V17.5563H14.5V25.9576H22.9013Z"
        fill={color ?? 'white'}
      />
      <path
        d="M34.0984 31.5586V34.359H38.1731C36.2408 37.7056 32.6282 39.9599 28.4976 39.9599C23.2887 39.9599 18.906 36.3754 17.6598 31.5586H14.7754C16.0776 37.9436 21.7205 42.7604 28.4976 42.7604C33.0763 42.7604 37.1509 40.548 39.6993 37.1455V39.9599H42.4998V31.5586H34.0984Z"
        fill={color ?? 'white'}
      />
    </svg>
  )
}

const CameraEnd = () => {
  return (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3318_336939" maskUnits="userSpaceOnUse" x="12" y="12" width="33" height="33">
        <rect x="12.5" y="12.7578" width="32" height="32" rx="12" fill="white" />
      </mask>
      <g mask="url(#mask0_3318_336939)">
        <path
          d="M34.1778 31.1244C34.1762 31.126 34.1753 31.1282 34.1753 31.1305C34.1772 31.9569 34.8581 32.6365 35.6849 32.6365L41.1477 32.6365C41.9758 32.6365 42.6574 31.9549 42.6574 31.1269L42.6624 29.0417C42.6624 26.2144 40.345 23.8969 37.5126 23.8919L19.3265 23.8919C16.4992 23.8919 14.1817 26.2093 14.1767 29.0417V31.1219C14.1767 31.9499 14.8583 32.6315 15.6863 32.6315H21.1492C21.9772 32.6315 22.6588 31.9499 22.6588 31.1219C22.6588 29.1461 23.9829 27.3883 25.9541 27.2555C28.1594 27.1068 30.3964 27.2744 31.9798 27.4584C33.2634 27.6076 34.1803 28.714 34.1803 30.0062L34.1803 31.1183C34.1803 31.1206 34.1794 31.1228 34.1778 31.1244Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

const NoticeIcon = (props: SvgPropsType) => {
  const { width, height, color } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49 18.2908C7.585 18.7636 8.755 19 10 19C11.245 19 12.415 18.7636 13.51 18.2908C14.605 17.8186 15.5575 17.1775 16.3675 16.3675C17.1775 15.5575 17.8186 14.605 18.2908 13.51C18.7636 12.415 19 11.245 19 10C19 8.755 18.7636 7.585 18.2908 6.49C17.8186 5.395 17.1775 4.4425 16.3675 3.6325C15.5575 2.8225 14.605 2.1811 13.51 1.7083C12.415 1.2361 11.245 1 10 1C8.755 1 7.585 1.2361 6.49 1.7083C5.395 2.1811 4.4425 2.8225 3.6325 3.6325C2.8225 4.4425 2.1814 5.395 1.7092 6.49C1.2364 7.585 1 8.755 1 10C1 11.245 1.2364 12.415 1.7092 13.51C2.1814 14.605 2.8225 15.5575 3.6325 16.3675C4.4425 17.1775 5.395 17.8186 6.49 18.2908ZM11.1566 8.30267V15.1428H8.84491V8.30267H11.1566ZM11.2865 6.05383C11.2865 6.79029 10.767 7.26373 10.0008 7.26373C9.22153 7.26373 8.71504 6.79029 8.71504 6.05383C8.71504 5.33052 9.22153 4.85708 10.0008 4.85708C10.767 4.85708 11.2865 5.33052 11.2865 6.05383Z"
        fill={color}
      />
    </svg>
  )
}

const ImageDetailXIcon = (props: SvgPropsType) => {
  const { width, height } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.7" cx="28.5" cy="28.9454" r="28" fill="black" />
      <path
        d="M20.1722 38.9454L18.5 37.2732L26.7912 28.9454L18.5 20.6176L20.1722 18.9454L28.5 27.2366L36.8278 18.9454L38.5 20.6176L30.2088 28.9454L38.5 37.2732L36.8278 38.9454L28.5 30.6543L20.1722 38.9454Z"
        fill="white"
      />
    </svg>
  )
}

const Svg = (props: SvgPropsType) => {
  const setSvgComponent = () => {
    switch (props.name) {
      case 'camera_cam':
        return <CameraCam {...props} />
      case 'camera_end':
        return <CameraEnd />
      case 'camera_mic':
        return <CameraMic {...props} />
      case 'camera_cam_rotate':
        return <CameraRotate {...props} />
      case 'home':
      case 'home_active':
        return <HomeIcon {...props} />
      case 'file_grey':
      case 'file_active':
      case 'file_black':
        return <FileIcon {...props} />
      case 'locate':
      case 'locate_active':
        return <LocateIcon {...props} />
      case 'video_call':
      case 'video_call_active':
        return <VideoCallIcon {...props} />
      case 'setting':
      case 'setting_active':
        return <SettingIcon {...props} />
      case 'wifi':
      case 'wifi_active':
        return <WifiIcon {...props} />
      case 'logo':
        return <LogoIcon {...props} />
      case 'pc_battery_full':
        return <PcBatteryFullIcon />
      case 'pc_battery_half':
        return <PcBatteryHalfIcon />
      case 'pc_battery_zero':
        return <PcBatteryZeroIcon />
      case 'mo_battery_full':
        return <MoBatteryFullIcon />
      case 'mo_battery_half':
        return <MoBatteryHalfIcon />
      case 'mo_battery_zero':
        return <MoBatteryZeroIcon />
      case 'arrow':
      case 'reverse_arrow':
        return <ArrowIcon {...props} />
      case 'right_arrow':
      case 'left_arrow':
        return <HorizontalArrowIcon {...props} />
      case 'xIcon':
        return <XIcon {...props} />
      case 'imagedetail_xIcon':
        return <ImageDetailXIcon {...props} />
      case 'wifiPower':
        return <WifiPowerIcon {...props} />
      case 'home_DeviceInfo_Reload_disabled':
      case 'home_DeviceInfo_Reload_active':
        return <HomeDeviceInfoReloadIcon {...props} />
      case 'location_sound':
        return <LocationSoundIcon {...props} />
      case 'location_reload':
        return <LocationReloadIcon {...props} />
      case 'location_device_lock':
        return <LocationLockIcon />
      case 'location_turn_off_attempt':
        return <LocationTurnOffAttempt />
      case 'location_first_lock':
        return <LocationFirstLock />
      case 'setting_unlock':
        return <SettingUnlockIcon />
      case 'setting_faq':
        return <SettingFaqIcon />
      case 'setting_Announcements':
        return <SettingAnnouncementIcon />
      case 'setting_signout':
        return <SettingSignOutIcon />
      case 'login_error':
        return <LoginErrorIcon />
      case 'pin_Input_eyes':
      case 'pin_Input_eyes_active':
        return <PinEyesIcon {...props} />
      case 'explorer_image_icon':
        return <ExplorerImageIcon {...props} />
      case 'explorer_video_icon':
        return <ExplorerVideoIcon {...props} />
      case 'explorer_audios_icon':
        return <ExplorerAudioIcon {...props} />
      case 'explorer_document_icon':
        return <ExplorerDocumentIcon {...props} />
      case 'explorer_down_icon':
        return <ExplorerDownIcon {...props} />
      case 'explorer_apk_icon':
        return <ExplorerApkIcon {...props} />
      case 'explorer_default_icon':
        return <ExplorerDefaultIcon />
      case 'explorer_deleteData_icon':
        return <ExplorerDeleteData />
      case 'view_user_guide_icon':
        return <ViewUserGuideIcon />
      case 'image_scale_icon':
        return <ImageScaleIcon />
      case 'image_reload_icon':
        return <ImageReloadIcon {...props} />
      case 'notice_icon':
        return <NoticeIcon {...props} />
      default:
    }
  }
  return (
    <SvgWrap {...props} onClick={props.onClick} style={props.style}>
      {setSvgComponent()}
    </SvgWrap>
  )
}
export default Svg

const SvgWrap = styled.section<SvgPropsType>`
  margin: ${(props) => props.$margin};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.onMouseDown || props.onClick) && 'pointer'};

  svg:hover #arrow_hover {
    &:hover {
      fill: ${COLOR.brand4};
    }
  }
`
